import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { DevicesProvider } from '../providers/devices/devices';
import { DatabaseProvider } from '../providers/database/database';
import { Storage } from '@ionic/storage';


export interface MenuItem {
  title: string;
  component: any;
  icon: string;
}

@Component({
  templateUrl: 'app.html'
})

export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = 'HomePage';
  lancaPedidos = false;
  firebasePlugin;

  appMenuItems: Array<MenuItem>;

  constructor(public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public dbProvider: DatabaseProvider,
    public events: Events,
    public alertCtrl: AlertController,
    public storage: Storage,
    public devicesProvider: DevicesProvider) {

    platform.ready().then(() => {
      this.firebasePlugin = (<any>window).FirebasePlugin;
      this.firebasePlugin.onMessageReceived(this.onMessageReceived.bind(this));
      this.getToken();

      this.initializeApp();

      this.events.subscribe('device:load', (result) => {
        this.lancaPedidos = result;
        this.carregarMenu();
      });
    });
  }

  carregarMenu() {
    this.appMenuItems = [];
    this.appMenuItems.push({ title: 'Home', component: 'HomePage', icon: 'home' });
    this.appMenuItems.push({ title: 'Entregas', component: 'ListEntregasPage', icon: 'basket' });
    if (this.lancaPedidos) {
      this.appMenuItems.push({ title: 'Pedidos', component: 'PedidosPage', icon: 'document' });
    }
    if (this.devicesProvider.dadosDevice.Dev_RealizaNFCe == 'S') {
      this.appMenuItems.push({ title: 'Lista de NFC-e', component: 'ListNfcePage', icon: 'globe' });
    }
    if (this.devicesProvider.dadosDevice.Ent_RealizaManifestoCarga == 'S') {
      this.appMenuItems.push({ title: 'Manifesto de Carga', component: 'ManifestoCargaPage', icon: 'cube' });
    }
    if (this.devicesProvider.dadosDevice.Ent_CodCaixa > 0) {
      this.appMenuItems.push({ title: 'Fechamento de Caixa', component: 'FechamentoCaixaPage', icon: 'calculator' });
    }
    if (this.lancaPedidos) {
      this.appMenuItems.push({ title: 'Sincronizar', component: 'SincronizarPage', icon: 'refresh-circle' });
    }
    this.appMenuItems.push({ title: 'Sobre', component: 'SobrePage', icon: 'information-circle' });

  }

  getToken() {
    console.log('gera token do firebase');
    this.firebasePlugin.getToken(token => {
      console.log("firebase token recebido", token);
      this.devicesProvider.atualizarDevice(token);
    });
  }

  onMessageReceived(message) {

    if (typeof (message) != 'object') {
      message = JSON.parse(message);
    }

    if (message.tap) {
      this.nav.push('DetailEntregaPage', { 'nroPedido': message.nroPedido, 'bd': message.bd });
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.

      //*** Control Status Bar
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);

      //*** Control Keyboard
      //this.keyboard.hide();

      this.storage.get('arrayDevice').then((result) => {
        if (result.length > 1) {
          this.rootPage = 'LoginPage'
        } else {
          this.rootPage = 'HomePage';
        }
      }).catch(e => console.log('erro dados device', e));

      this.dbProvider.createDatabase().then(() => {
        this.splashScreen.hide();
      });
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.push(page.component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts